/**
 * API-Client für /api/sessions (Phase W, Kapitel 3.5, Entscheidung #32).
 */

import { apiFetch } from './api';

export interface ApiSession {
  id: string;
  deviceLabel: string | null;
  lastActiveAt: string;
  createdAt: string;
  isCurrent: boolean;
}

export const sessionsApi = {
  list: (token: string) =>
    apiFetch<{ sessions: ApiSession[] }>('/api/sessions', { token }).then((r) => r.sessions),

  revokeOthers: (token: string) =>
    apiFetch<{ ok: true; revokedCount: number }>('/api/sessions/revoke-others', {
      method: 'POST',
      token,
    }),
};
